import React from 'react';
import ListPills from './ListPills';

const ShowFs = ({fs}) =>  <ListPills pillVal = {fs}   />
 
export default ShowFs;